import { buildProps, definePropType } from '@jdesign-vue/utils'

import {
  flexAlignValues,
  flexGapValues,
  flexJustifyValues,
  flexWrapValues,
} from './constants'

import type { ExtractPropTypes, StyleValue } from 'vue'
import type Flex from './flex.vue'

export type FlexJustify = (typeof flexJustifyValues)[number]
export type FlexAlign = (typeof flexAlignValues)[number]
export type FlexWrap = (typeof flexWrapValues)[number]
export type FlexGap = (typeof flexGapValues)[number]

export const flexProps = buildProps({
  /**
   * @description flex 主轴方向是否垂直
   */
  vertical: Boolean,
  /**
   * @description 设置元素单行显示还是多行显示
   */
  wrap: {
    type: definePropType<boolean | FlexWrap>([Boolean, String]),
    default: 'nowrap',
  },
  /**
   * @description 设置元素在主轴方向上的对齐方式
   */
  justify: {
    type: String,
    values: flexJustifyValues,
    default: 'normal',
  },
  /**
   * @description 设置元素在交叉轴方向上的对齐方式
   */
  align: {
    type: String,
    values: flexAlignValues,
    default: 'normal',
  },
  /**
   * @description flex CSS 简写属性
   */
  flex: {
    type: [String, Number],
  },
  /**
   * @description 设置子元素之间的间隙
   */
  gap: {
    type: definePropType<FlexGap | string | number>([String, Number]),
  },
  /**
   * @description 自定义元素类型
   */
  tag: {
    type: String,
    default: 'div',
  },
  /**
   * @description 类名
   */
  class: {
    type: definePropType<string | Record<string, boolean> | Array<string | Record<string, boolean>>>(
      [String, Object, Array]
    ),
    default: '',
  },
  /**
   * @description 额外样式
   */
  style: {
    type: definePropType<StyleValue>([String, Array, Object]),
    default: '',
  },
} as const)

export type FlexProps = ExtractPropTypes<typeof flexProps>
export type FlexInstance = InstanceType<typeof Flex>
